<template>
  <div class="col-md-12">
    <Header></Header>

    <div class="condition-head-text">
      <b>Avant de créer un compte et déposer un dossier de candidature, vous attestez sur l'honneur justifier des critères d’éligibilité suivants :</b>
    </div>

    <div class="condition-group">
      <div class="condition-row">
        <div><img src="@/assets/img/raster.png"></div>
        <div class="condition-text">J’atteste avoir plus de 18 ans</div>
        <div class="custom-control custom-switch">
          <input id="customSwitch1" v-model="customSwitch1" class="custom-control-input" type="checkbox">
          <label class="custom-control-label" for="customSwitch1"></label>
        </div>
      </div>
      <div class="condition-row">
        <div><img src="@/assets/img/raster.png"></div>
        <div class="condition-text">J’atteste avoir obtenu un titre ou un diplôme de niveau 4 (Baccalauréat ou équivalent)</div>
        <div class="custom-control custom-switch">
          <input id="customSwitch2" v-model="customSwitch2" class="custom-control-input" type="checkbox">
          <label class="custom-control-label" for="customSwitch2"></label>
        </div>
      </div>
      <div class="condition-row">
        <div><img src="@/assets/img/raster.png"></div>
        <div class="condition-text">J’atteste justifier d’une immersion en clinique vétérinaire de 70 heures minimum au cours des deux dernières années et équivalente à 2 semaines (ces semaines ne sont pas obligatoirement consécutives). Type de contrat accepté : CDD, <a href="https://travail-emploi.gouv.fr/formation-professionnelle/formation-des-demandeurs-d-emploi/article/periodes-de-mise-en-situation-en-milieu-professionnel-pmsmp" target="_blank">PMSMP</a>, stage …</div>
        <div class="custom-control custom-switch">
          <input id="customSwitch3" v-model="customSwitch3" class="custom-control-input" type="checkbox">
          <label class="custom-control-label" for="customSwitch3"></label>
        </div>
      </div>
    </div>

    <div class="login-group">
      <button :disabled='isDisabled' class="btn btn-primary btn-block" v-on:click="register">
        <span>Créer un compte</span>
      </button>

      <div class="login-group-info">Vous avez déjà un compte ?</div>
      <div class="login-group-href">
        <router-link :to="{ name: 'public-login'}">Se connecter</router-link>
      </div>
      <div class="login-group-help">
        <router-link :to="{ name: 'public-help-candidature'}" target="_blank">Aide à la candidature</router-link>
      </div>
    </div>
  </div>
</template>

<script>

import Header from "./Header.vue";

export default {
  name: "Approach",
  components: {
    Header
  },
  methods: {
    register: function () {
      this.$router.push({name: 'public-register'});
    }
  },
  data() {
    return {
      customSwitch1: false,
      customSwitch2: false,
      customSwitch3: false,
    };
  },
  computed: {
    isDisabled: function () {
      if (this.customSwitch1 && this.customSwitch2 && this.customSwitch3) return false;
      return true;
    }
  },

};
</script>

<style>

</style>